import { Group, Text } from '@mantine/core';

type BillSummaryRowProps = {
  label: string;
  units: number;
  bill: string;
  calculatedBill?: string | null;
  isMinApplied: boolean;
};

export function BillSummaryRow({
  label,
  units,
  bill,
  calculatedBill,
  isMinApplied: minApplied,
}: BillSummaryRowProps) {
  return (
    <Group justify="space-between">
      <Text size="sm" fw={600} c="green">
        {label}
      </Text>
      <Group gap="xs">
        <Text size="xs" c="dimmed">
          {units} units →
        </Text>
        {minApplied && calculatedBill ? (
          <>
            <Text size="sm" c="dimmed" td="line-through">
              {calculatedBill}
            </Text>
            <Text size="sm" fw={600} c="green">
              {bill}
            </Text>
          </>
        ) : (
          <Text size="sm" fw={600} c="green">
            {bill}
          </Text>
        )}
      </Group>
    </Group>
  );
}
